import React from "react";
import {Navigate, Outlet, useRouteLoaderData} from "react-router";
import {LoadedData} from "@/context/authentication/user-loader";
import router from "@/routing/Router";

const OnlyUnauthenticatedRedirect = () => {
    const {user} = useRouteLoaderData("auth-root") as LoadedData;

    if (user !== null) {
        return <Navigate to={router.index.absolutePath()} replace/>;
    }

    return <Outlet/>;
};

export default OnlyUnauthenticatedRedirect;